import type {
  ITournament,
  TopPlayer,
} from '@/modules/common/hooks/useTournaments';
import { request } from './base';

export const tournamentBackend = (id: string) =>
  request<ITournament>({ url: `tournaments/${id}` });

export const userTournamentStatus = () =>
  request<TopPlayer[]>({ url: 'tournaments/statuses' });
